/* ÀMBA Drawer Menu — HOCB-style navigation with persistent CLOSE header */
(function () {
  function initAmbaDrawer() {
    var drawer = document.getElementById('mobile-menu');

    if (!drawer || drawer.dataset.ambaStatesReady === 'true') return;

    var header = drawer.querySelector(':scope > header');
    var heading = header && header.querySelector('h6');
    var content = drawer.querySelector('.side-panel-content');

    var menu = drawer.querySelector(
      '.amba-drawer-main-menu, .mobile-menu:not(.mobile-secondary-menu)'
    );

    if (!header || !heading || !menu || !content) return;

    drawer.dataset.ambaStatesReady = 'true';

    /* Persistent CLOSE label in the top-left corner */
    heading.textContent = 'CLOSE';
    heading.hidden = false;
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-label', 'Close menu');

    /* Place back navigation inside the content, below CLOSE */
    var back = document.createElement('button');
    back.type = 'button';
    back.className = 'amba-drawer-back';
    back.setAttribute('aria-label', 'Back to main menu');
    back.hidden = true;

    back.innerHTML =
      '<span class="amba-drawer-back__arrow" aria-hidden="true">‹</span>' +
      '<span class="amba-drawer-back__label"></span>';

    content.insertBefore(back, menu);

    var topItems = Array.from(menu.children).filter(function (item) {
      return item.matches('li');
    });

    var currentItem = null;

    /* HOCB-style progress track for the COLLECTIONS mobile/tablet carousel. */
    var collectionsCarousel = drawer.querySelector('.amba-collections-mobile-carousel');
    var collectionsProgress = drawer.querySelector('.amba-collections-carousel-progress__thumb');

function updateCollectionsProgress() {
  if (!collectionsCarousel || !collectionsProgress) return;

  var track = collectionsProgress.parentElement;
  var viewport = collectionsCarousel.clientWidth;
  var fullWidth = collectionsCarousel.scrollWidth;
  var maxScroll = Math.max(
    0,
    fullWidth - viewport
  );
  var trackWidth = track.clientWidth;

  if (!viewport || !fullWidth || !trackWidth) return;

  var thumbWidth = Math.min(
    trackWidth,
    trackWidth * viewport / fullWidth
  );

  var scrollRatio = maxScroll > 0
    ? Math.max(
        0,
        Math.min(1, collectionsCarousel.scrollLeft / maxScroll)
      )
    : 0;

  var maxTravel = trackWidth - thumbWidth;
  var thumbLeft = scrollRatio * maxTravel;

  collectionsProgress.style.width = thumbWidth + 'px';
  collectionsProgress.style.left = thumbLeft + 'px';
  collectionsProgress.style.transform = 'none';

  track.hidden = maxScroll <= 1;
}
    if (collectionsCarousel && collectionsProgress) {
      collectionsCarousel.addEventListener('scroll', updateCollectionsProgress, { passive: true });


      window.addEventListener('resize', updateCollectionsProgress);
      window.setTimeout(updateCollectionsProgress, 100);
      window.setTimeout(updateCollectionsProgress, 500);
    }

    function getSubmenu(item) {
      return item.querySelector(':scope > .sub-menu');
    }

    function setPromoState(isHeadingOpen, item) {
      drawer.classList.toggle('amba-heading-view', isHeadingOpen);
      drawer.classList.remove('amba-edits-view', 'amba-clothing-view', 'amba-collections-view');

      if (!isHeadingOpen || !item) return;

      var link = item.querySelector(':scope > .link-container > a');
      var title = link
        ? ((link.getAttribute('title') || '') + ' ' + link.textContent)
            .replace(/\s+/g, ' ')
            .trim()
            .toLocaleUpperCase()
        : '';

      if (title === 'EDITS' || /\bEDITS\b/.test(title)) {
        drawer.classList.add('amba-edits-view');
      } else if (title === 'CLOTHING' || /\bCLOTHING\b/.test(title)) {
        drawer.classList.add('amba-clothing-view');
      } else if (title === 'COLLECTIONS' || /\bCOLLECTIONS\b/.test(title)) {
        drawer.classList.add('amba-collections-view');
      }
    }

function itemLinkIsCollections(item) {
  var link = item.querySelector(':scope > .link-container > a');

  return !!link &&
    link.textContent.replace(/\s+/g, ' ').trim().toUpperCase() === 'COLLECTIONS';
}

    /* Open the selected heading */
    function openHeading(item) {
      var submenu = getSubmenu(item);

      if (!submenu) return;

      currentItem = item;
      setPromoState(true, item);

      topItems.forEach(function (node) {
        node.classList.remove('amba-current-view');
        node.hidden = true;

        var childMenu = getSubmenu(node);

        if (childMenu) {
          childMenu.style.setProperty('display', 'none', 'important');
          childMenu.setAttribute('aria-hidden', 'true');
        }
      });

      item.hidden = false;

      item.classList.add(
        'amba-current-view',
        'amba-submenu-page'
      );

      var isCollectionsView = drawer.classList.contains('amba-collections-view');
      var useCollectionsCarousel =
        isCollectionsView && window.matchMedia('(max-width: 999px)').matches;

      if (useCollectionsCarousel) {
        submenu.style.setProperty('display', 'none', 'important');
        submenu.setAttribute('aria-hidden', 'true');
      } else {
        submenu.style.setProperty('display', 'grid', 'important');
        submenu.setAttribute('aria-hidden', 'false');
      }

      var link = item.querySelector(':scope > .link-container > a');

      back.querySelector('.amba-drawer-back__label').textContent =
        link ? link.textContent.trim() : 'MENU';

back.hidden = false;

content.scrollTop = 0;

/* Recalculate the progress bar after COLLECTIONS becomes visible */
if (
  drawer.classList.contains('amba-collections-view') &&
  window.matchMedia('(max-width: 999px)').matches
) {
  window.requestAnimationFrame(function () {
    updateCollectionsProgress();

    window.requestAnimationFrame(function () {
      updateCollectionsProgress();
    });
  });
}



/* Recalculate COLLECTIONS carousel after it becomes visible */
if (
  itemLinkIsCollections(item) &&
  collectionsCarousel &&
  collectionsProgress
) {
  window.requestAnimationFrame(function () {
    updateCollectionsProgress();

    window.requestAnimationFrame(function () {
      updateCollectionsProgress();
    });
  });
}
    }

    /* Return to the main menu without leaving any submenu visible */
    function closeHeading() {
      currentItem = null;
      setPromoState(false, null);

      topItems.forEach(function (item) {
        item.hidden = false;

        item.classList.remove(
          'amba-current-view',
          'amba-submenu-page',
          'is-open',
          'active'
        );

        var submenu = getSubmenu(item);

        if (submenu) {
          submenu.style.setProperty('display', 'none', 'important');
          submenu.setAttribute('aria-hidden', 'true');
        }

        var toggle = item.querySelector(
          ':scope > .link-container > span'
        );

        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      back.hidden = true;

      back.querySelector('.amba-drawer-back__label').textContent = '';

      content.scrollTop = 0;
    }

    /* Close the entire drawer using Shopify's native close control */
    function closeDrawer() {
      var nativeClose = header.querySelector(
        '.thb-close, [data-drawer-close], .side-panel-close'
      ) || drawer.querySelector(
        '.thb-close, [data-drawer-close], .side-panel-close'
      );

      if (nativeClose) {
        nativeClose.click();
        return;
      }

      /* Fallback if the native close control is unavailable */
      drawer.classList.remove('open', 'active');

      var wrapper = document.getElementById('wrapper');

      if (wrapper) {
        wrapper.classList.remove('open-cc');
      }

      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }

    /* CLOSE works with both mouse and keyboard */
    heading.addEventListener('click', closeDrawer);

    heading.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        closeDrawer();
      }
    });

    /* Back arrow returns to the main menu */
    back.addEventListener('click', closeHeading);

    /* Bind submenu navigation to existing Shopify menu items */
    topItems.forEach(function (item) {
      var link = item.querySelector(':scope > .link-container > a');
      var toggle = item.querySelector(':scope > .link-container > span');
      var submenu = getSubmenu(item);

      if (!submenu || !link) return;

      function handleOpen(event) {
        event.preventDefault();
        openHeading(item);
      }

      link.addEventListener('click', handleOpen);

      if (toggle) {
        toggle.setAttribute('role', 'button');
        toggle.setAttribute('tabindex', '0');
        toggle.setAttribute('aria-expanded', 'false');

        toggle.addEventListener('click', handleOpen);

        toggle.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOpen(event);
          }
        });
      }
    });

    /* Reset navigation state whenever Shopify closes the drawer */
    drawer.querySelectorAll(
      '.thb-close, [data-drawer-close], .side-panel-close'
    ).forEach(function (button) {
      button.addEventListener('click', function () {
        window.setTimeout(closeHeading, 350);
      });
    });

    /* Observe drawer visibility changes */
    var observer = new MutationObserver(function () {
      var wrapper = document.getElementById('wrapper');

      var isOpen = drawer.classList.contains('amba-menu-open');

      if (!isOpen && currentItem) {
        closeHeading();
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    var wrapper = document.getElementById('wrapper');

    if (wrapper) {
      observer.observe(wrapper, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  /* Shopify may render the drawer after the initial page load */
  function safeInit() {
    initAmbaDrawer();

    window.setTimeout(initAmbaDrawer, 250);
    window.setTimeout(initAmbaDrawer, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }

  document.addEventListener('shopify:section:load', safeInit);
})();